import { LucideProps } from "lucide-react"

export const AllProductsIcons = {
  arrowUp: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        d="M8.20694 4.80606L5.00114 1.99384L1.79534 4.80606C1.47311 5.08873 0.952579 5.08873 0.630346 4.80606C0.308114 4.52339 0.308114 4.06677 0.630346 3.78409L4.42278 0.457258C4.74501 0.174586 5.26554 0.174586 5.58777 0.457258L9.3802 3.78409C9.70243 4.06677 9.70243 4.52339 9.3802 4.80606C9.05797 5.08149 8.52918 5.08873 8.20694 4.80606Z"
        fill="black"
      />
    </svg>
  ),
  arrowDown: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
    >
      <path
        d="M8.53116 1.18918L5.32536 4.0014L2.11956 1.18918C1.79733 0.906505 1.2768 0.906505 0.954565 1.18918C0.632332 1.47185 0.632332 1.92847 0.954565 2.21115L4.74699 5.53798C5.06923 5.82065 5.58976 5.82065 5.91199 5.53798L9.70442 2.21115C10.0267 1.92847 10.0267 1.47185 9.70442 1.18918C9.38219 0.913753 8.85339 0.906505 8.53116 1.18918Z"
        fill="black"
      />
    </svg>
  ),
  windows: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <g clipPath="url(#clip0_1236_10979)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.86003 8.36663C7.86405 9.96945 7.86887 12.6927 7.87289 14.8093C10.7708 15.2012 13.6688 15.6051 16.5619 16.0371C16.5619 13.5102 16.5651 10.9944 16.5619 8.59019C13.6615 8.59019 10.762 8.36663 7.86003 8.36663ZM0.526367 8.36741V13.8093C2.71208 14.1042 4.89779 14.3861 7.07948 14.7083C7.08349 12.6029 7.07787 10.497 7.07787 8.39168C4.89377 8.39569 2.71047 8.3602 0.526367 8.36741ZM0.526367 2.27988V7.7065C2.71208 7.71212 4.89779 7.67904 7.08349 7.68145C7.08189 5.58094 7.08189 3.483 7.07948 1.3825C4.89216 1.65578 2.70484 1.94489 0.526367 2.27988ZM16.5635 7.59492C13.6672 7.60614 10.7708 7.65031 7.87289 7.65913C7.87128 5.52416 7.87128 3.39174 7.87289 1.25838C10.7652 0.816799 13.6639 0.401505 16.5619 0C16.5635 2.53247 16.5619 5.06245 16.5635 7.59492Z"
          fill="#3C8FF0"
        />
      </g>
      <defs>
        <clipPath id="clip0_1236_10979">
          <rect
            width="16.0371"
            height="16.0371"
            fill="white"
            transform="translate(0.526367)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  hp: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <g clipPath="url(#clip0_1236_10987)">
        <path
          d="M8.54443 17.3325H8.26851L10.0004 12.6912H12.3548C12.7716 12.6912 13.1857 12.3447 13.3239 11.9986L15.1966 6.94058C15.4726 6.10971 14.9883 5.41705 14.1574 5.41705H10.8988L6.67431 17.1247C2.93147 16.2236 0.230469 12.9677 0.230469 9.01907C0.230469 5.20868 2.79325 2.02027 6.32772 0.981029L4.73352 5.41653L2.03252 12.6912H3.76442L5.98113 6.52333H7.2963L5.07959 12.6912H6.81149L8.88998 6.94006C9.1659 6.10919 8.75176 5.41653 7.85074 5.41653H6.4649L8.19681 0.70459H8.54339C13.1171 0.70459 16.8574 4.44483 16.8574 9.01855C16.8574 13.5923 13.1171 17.3325 8.54339 17.3325H8.54443ZM13.6024 6.45577H12.2847L10.4146 11.5138H11.7323L13.6024 6.45577Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1236_10987">
          <rect
            width="16.6279"
            height="16.6279"
            fill="white"
            transform="translate(0.230469 0.70459)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  acer: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1236_10992)">
        <path
          d="M21.6259 5.47384C21.5515 5.36555 21.4772 5.28409 21.1053 5.25725C21.0064 5.25725 20.7089 5.22946 20.1883 5.22946C18.8233 5.22946 17.8818 5.69138 17.4102 6.58742C17.5344 5.69138 16.7408 5.22946 15.0048 5.22946C12.9713 5.22946 11.6815 6.1255 11.1609 7.94538C10.9632 8.62484 10.9632 9.16821 11.1119 9.60329H10.6158C10.2439 9.62917 9.74778 9.65696 9.42578 9.65696C8.68203 9.65696 8.20953 9.52088 8.03628 9.24967C7.88753 9.00529 7.88753 8.54338 8.08616 7.86392C8.40816 6.75034 9.17728 6.26159 10.4172 6.26159C11.062 6.26159 11.6815 6.34304 11.6815 6.34304C11.7559 6.34304 11.8058 6.23475 11.8058 6.15329L11.7813 6.07184L11.7314 5.69138C11.7069 5.447 11.5328 5.31092 11.2353 5.25725C10.9632 5.22946 10.7392 5.22946 10.4417 5.22946H10.4172C8.80541 5.22946 7.66441 5.82746 7.04491 6.96788C7.26803 5.79967 6.52341 5.22946 4.81278 5.22946C3.84591 5.22946 3.15028 5.25725 2.75391 5.31092C2.43191 5.36555 2.23328 5.50163 2.15891 5.746L2.01016 6.23475C1.98566 6.31621 2.03553 6.37084 2.13441 6.37084C2.20878 6.37084 2.50628 6.31621 3.00241 6.28842C3.4891 6.24325 3.97704 6.21608 4.46541 6.20696C5.40778 6.20696 5.82953 6.47913 5.68078 6.99471C5.65541 7.10396 5.58103 7.18542 5.45766 7.21225C4.56516 7.37517 3.84591 7.48442 3.32441 7.56588C1.83691 7.78246 0.968906 8.27121 0.745781 9.08675C0.422906 10.2003 1.21653 10.7428 3.12578 10.7428C4.06903 10.7428 4.88716 10.6891 5.53203 10.553C5.90391 10.4715 6.10253 10.3901 6.17691 10.1189L6.52341 8.86921C6.49891 10.1189 7.26716 10.7428 8.90428 10.7428C9.59903 10.7428 10.2684 10.7159 10.5904 10.6613C10.9133 10.6076 11.0865 10.5262 11.1609 10.254L11.2353 9.8745C11.5827 10.4715 12.3518 10.7705 13.5173 10.7705C14.7572 10.7705 15.4764 10.7428 15.6742 10.6613C15.7459 10.6437 15.8127 10.6074 15.8689 10.5555C15.9251 10.5036 15.969 10.4377 15.997 10.3633L16.0215 10.2818L16.1703 9.76525C16.1957 9.68379 16.1458 9.62917 16.046 9.62917L15.2533 9.68379C14.7318 9.71159 14.3109 9.73842 14.0125 9.73842C13.4429 9.73842 13.071 9.68379 12.847 9.60234C12.525 9.46625 12.3763 9.22188 12.4008 8.81459L14.9059 8.46192C16.0215 8.299 16.7907 7.91854 17.1625 7.3215L16.2945 10.4984C16.27 10.553 16.2945 10.6076 16.319 10.6345C16.3444 10.6613 16.3934 10.6891 16.4932 10.6891H17.5344C17.7077 10.6891 17.782 10.5798 17.8074 10.4984L18.7244 6.99471C18.8487 6.53375 19.2205 6.31621 19.9144 6.31621C20.5357 6.31621 20.9819 6.31621 21.2794 6.34304H21.3039C21.3538 6.34304 21.4527 6.31621 21.527 6.18013L21.6758 5.69138C21.6758 5.60992 21.6758 5.52846 21.6259 5.47384ZM4.91166 9.65792C4.58966 9.71254 4.11803 9.73938 3.52303 9.73938C2.45641 9.73938 2.01016 9.495 2.13441 9.03309C2.23328 8.70725 2.50628 8.48971 2.95253 8.43509L5.35878 8.08242L4.91166 9.65792ZM15.997 6.83084C15.8973 7.18446 15.4265 7.42884 14.583 7.56492L12.5749 7.86296L12.6239 7.67321C12.798 7.07521 13.0212 6.69571 13.3187 6.47817C13.6162 6.26063 14.1123 6.15234 14.8062 6.15234C15.7249 6.17917 16.1222 6.39671 15.997 6.83084Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1236_10992">
          <rect
            width="21"
            height="23"
            fill="white"
            transform="translate(0.675781 -3.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  apple: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1236_10997)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.82686 2.90056C10.373 2.26758 10.7411 1.38597 10.6404 0.508789C9.85338 0.538753 8.90122 1.01154 8.33689 1.64377C7.83013 2.20484 7.38777 3.10134 7.50669 3.96129C8.38461 4.02645 9.28072 3.53428 9.82686 2.90056ZM11.7956 8.46794C11.8175 10.7354 13.8711 11.4897 13.8938 11.4994C13.8771 11.5526 13.5658 12.5742 12.8121 13.6304C12.1599 14.5428 11.4835 15.4515 10.4177 15.471C9.37086 15.4897 9.03378 14.8762 7.83619 14.8762C6.63937 14.8762 6.26517 15.4514 5.27439 15.4896C4.24572 15.5263 3.46173 14.5025 2.80499 13.5931C1.46121 11.7331 0.434822 8.33691 1.81344 6.04472C2.49821 4.90685 3.72154 4.1852 5.05017 4.16722C6.05989 4.14849 7.01357 4.81829 7.63092 4.81829C8.24827 4.81829 9.40722 4.01302 10.6253 4.13137C11.135 4.1516 12.5667 4.32832 13.4855 5.6175C13.4113 5.66169 11.7774 6.57276 11.7956 8.46794Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1236_10997">
          <rect
            width="14.9819"
            height="14.9819"
            fill="white"
            transform="translate(0.0351562 0.508789)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  green_tick: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M2.2793 9.49558L4.5249 11.8481L5.18192 11.1598M11.2617 4.79053L7.37169 8.86579"
        stroke="#2E8016"
        strokeWidth="0.962402"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.48828 9.49558L7.73389 11.8481L14.4707 4.79053"
        stroke="#2E8016"
        strokeWidth="0.962402"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  filters_icon: (props: LucideProps) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.99207 17.4229V14.9831"
        stroke="black"
        strokeWidth="1.21991"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1249 17.4229V12.5432"
        stroke="black"
        strokeWidth="1.21991"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1249 5.22379V2.78397"
        stroke="black"
        strokeWidth="1.21991"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99207 7.6636V2.78397"
        stroke="black"
        strokeWidth="1.21991"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99207 14.9831C5.23419 14.9831 4.85526 14.9831 4.55634 14.8593C4.15779 14.6942 3.84114 14.3775 3.67606 13.979C3.55225 13.68 3.55225 13.3011 3.55225 12.5432C3.55225 11.7854 3.55225 11.4065 3.67606 11.1075C3.84114 10.709 4.15779 10.3923 4.55634 10.2272C4.85526 10.1034 5.23419 10.1034 5.99207 10.1034C6.74994 10.1034 7.12888 10.1034 7.42779 10.2272C7.82634 10.3923 8.14299 10.709 8.30807 11.1075C8.43189 11.4065 8.43188 11.7854 8.43188 12.5432C8.43188 13.3011 8.43189 13.68 8.30807 13.979C8.14299 14.3775 7.82634 14.6942 7.42779 14.8593C7.12888 14.9831 6.74994 14.9831 5.99207 14.9831Z"
        stroke="black"
        strokeWidth="1.21991"
      />
      <path
        d="M14.1249 10.1034C13.367 10.1034 12.9881 10.1034 12.6891 9.97964C12.2906 9.81455 11.9739 9.49786 11.8088 9.09936C11.6851 8.8004 11.6851 8.42148 11.6851 7.6636C11.6851 6.90573 11.6851 6.5268 11.8088 6.22788C11.9739 5.82933 12.2906 5.51268 12.6891 5.3476C12.9881 5.22379 13.367 5.22379 14.1249 5.22379C14.8828 5.22379 15.2617 5.22379 15.5606 5.3476C15.9591 5.51268 16.2758 5.82933 16.4409 6.22788C16.5647 6.5268 16.5647 6.90573 16.5647 7.6636C16.5647 8.42148 16.5647 8.8004 16.4409 9.09936C16.2758 9.49786 15.9591 9.81455 15.5606 9.97964C15.2617 10.1034 14.8828 10.1034 14.1249 10.1034Z"
        stroke="black"
        strokeWidth="1.21991"
      />
    </svg>
  ),
  dell: (props: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      {...props}
    >
      <g id="surface1">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(0%,0%,0%)",
            fillOpacity: 1,
          }}
          d="M 11.976562 9.734375 L 11.976562 6.214844 L 12.789062 6.214844 L 12.789062 9.019531 L 14.214844 9.019531 L 14.214844 9.730469 L 11.976562 9.730469 Z M 5.453125 7.542969 L 7.441406 6.011719 C 7.628906 6.164062 7.8125 6.316406 8 6.472656 L 6.113281 7.898438 L 6.523438 8.253906 L 8.40625 6.777344 C 8.59375 6.929688 8.78125 7.085938 8.96875 7.238281 C 8.34375 7.734375 7.714844 8.222656 7.082031 8.714844 L 7.488281 9.070312 L 9.378906 7.542969 L 9.375 6.21875 L 10.191406 6.21875 L 10.191406 9.019531 L 11.667969 9.019531 L 11.667969 9.734375 L 9.425781 9.734375 L 9.425781 8.410156 C 8.761719 8.917969 8.101562 9.425781 7.441406 9.933594 L 5.453125 8.410156 C 5.355469 8.894531 5.019531 9.316406 4.578125 9.535156 C 4.386719 9.636719 4.179688 9.699219 3.96875 9.722656 C 3.847656 9.738281 3.722656 9.734375 3.601562 9.734375 L 2.34375 9.734375 L 2.34375 6.21875 L 3.792969 6.21875 C 4.171875 6.222656 4.539062 6.351562 4.835938 6.589844 C 5.136719 6.828125 5.355469 7.171875 5.453125 7.542969 Z M 3.109375 6.929688 L 3.109375 9.070312 L 3.746094 9.070312 C 4.015625 9.058594 4.269531 8.933594 4.433594 8.722656 C 4.722656 8.363281 4.769531 7.867188 4.558594 7.460938 C 4.425781 7.207031 4.1875 7.019531 3.90625 6.949219 C 3.792969 6.925781 3.679688 6.929688 3.566406 6.929688 Z M 7.878906 0 L 8.105469 0 C 9.363281 0.015625 10.597656 0.332031 11.707031 0.914062 C 12.792969 1.488281 13.734375 2.296875 14.457031 3.285156 C 15.4375 4.621094 15.976562 6.226562 16 7.878906 L 16 8.121094 C 15.972656 10.113281 15.203125 12.023438 13.84375 13.476562 C 12.359375 15.058594 10.289062 15.972656 8.121094 16 L 7.878906 16 C 6.933594 15.988281 6 15.804688 5.117188 15.464844 C 4.039062 15.042969 3.070312 14.398438 2.265625 13.574219 C 1.40625 12.6875 0.761719 11.621094 0.382812 10.449219 C 0.140625 9.695312 0.0117188 8.910156 0 8.121094 L 0 7.882812 C 0.0234375 6.363281 0.484375 4.882812 1.328125 3.617188 C 2.113281 2.429688 3.195312 1.472656 4.46875 0.835938 C 5.527344 0.304688 6.695312 0.0195312 7.878906 0 Z M 7.777344 0.820312 C 6.214844 0.863281 4.707031 1.421875 3.492188 2.402344 C 2.496094 3.207031 1.730469 4.257812 1.277344 5.453125 C 0.621094 7.207031 0.667969 9.144531 1.40625 10.863281 C 1.917969 12.042969 2.734375 13.058594 3.769531 13.8125 C 4.714844 14.5 5.808594 14.945312 6.960938 15.109375 C 7.933594 15.25 8.933594 15.195312 9.878906 14.9375 C 11.175781 14.585938 12.347656 13.878906 13.261719 12.898438 C 14.175781 11.914062 14.796875 10.695312 15.050781 9.375 C 15.253906 8.339844 15.222656 7.277344 14.972656 6.253906 C 14.375 3.859375 12.585938 1.9375 10.238281 1.167969 C 9.445312 0.910156 8.613281 0.792969 7.777344 0.820312 Z M 7.777344 0.820312 "
        />
      </g>
    </svg>
  ),
  lenovo: (props: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      {...props}
    >
      <g id="surface1">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(0%,0%,0%)",
            fillOpacity: 1,
          }}
          d="M 14.03125 8.191406 C 14.03125 8.523438 13.800781 8.769531 13.484375 8.769531 C 13.175781 8.769531 12.933594 8.515625 12.933594 8.191406 C 12.933594 7.851562 13.164062 7.613281 13.476562 7.613281 C 13.789062 7.613281 14.03125 7.867188 14.03125 8.191406 Z M 4.492188 7.578125 C 4.324219 7.574219 4.160156 7.648438 4.058594 7.785156 C 3.957031 7.925781 3.914062 8.101562 3.945312 8.273438 L 4.929688 7.867188 C 4.855469 7.691406 4.683594 7.578125 4.492188 7.578125 Z M 9.132812 7.613281 C 8.820312 7.613281 8.589844 7.851562 8.589844 8.191406 C 8.589844 8.515625 8.832031 8.769531 9.144531 8.769531 C 9.457031 8.769531 9.6875 8.523438 9.6875 8.191406 C 9.6875 7.867188 9.445312 7.613281 9.132812 7.613281 Z M 16 5.332031 L 16 10.667969 L 0 10.667969 L 0 5.332031 Z M 3.339844 8.699219 L 2.058594 8.699219 L 2.058594 6.550781 L 1.488281 6.550781 L 1.488281 9.21875 L 3.339844 9.21875 Z M 4.097656 8.636719 L 5.539062 8.039062 C 5.515625 7.828125 5.429688 7.628906 5.292969 7.464844 C 5.105469 7.246094 4.824219 7.128906 4.484375 7.128906 C 3.863281 7.128906 3.394531 7.585938 3.394531 8.191406 C 3.394531 8.8125 3.863281 9.253906 4.542969 9.253906 C 4.925781 9.253906 5.316406 9.070312 5.5 8.859375 L 5.144531 8.585938 C 4.90625 8.761719 4.769531 8.804688 4.550781 8.804688 C 4.359375 8.804688 4.207031 8.742188 4.097656 8.636719 Z M 7.8125 7.945312 C 7.8125 7.472656 7.472656 7.128906 6.976562 7.128906 C 6.714844 7.128906 6.46875 7.25 6.308594 7.457031 L 6.308594 7.164062 L 5.742188 7.164062 L 5.742188 9.21875 L 6.308594 9.21875 L 6.308594 8.050781 C 6.308594 7.839844 6.46875 7.617188 6.773438 7.617188 C 7.003906 7.617188 7.246094 7.777344 7.246094 8.050781 L 7.246094 9.21875 L 7.8125 9.21875 Z M 10.242188 8.191406 C 10.242188 7.589844 9.757812 7.128906 9.144531 7.128906 C 8.519531 7.128906 8.035156 7.597656 8.035156 8.191406 C 8.035156 8.792969 8.519531 9.253906 9.132812 9.253906 C 9.757812 9.253906 10.242188 8.785156 10.242188 8.191406 Z M 11.621094 9.21875 L 12.464844 7.164062 L 11.820312 7.164062 L 11.3125 8.5625 L 10.800781 7.164062 L 10.15625 7.164062 L 11.003906 9.21875 Z M 14.585938 8.191406 C 14.585938 7.589844 14.101562 7.128906 13.484375 7.128906 C 12.863281 7.128906 12.378906 7.597656 12.378906 8.191406 C 12.378906 8.792969 12.863281 9.253906 13.476562 9.253906 C 14.097656 9.253906 14.585938 8.785156 14.585938 8.191406 Z M 14.585938 8.191406 "
        />
      </g>
    </svg>
  ),
}
